import styled from 'styled-components';

import { headerVariables } from '../Header/HeaderStyle';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

const toolsListVariables = {
  main: { height: { iphone: 144 } },
};

export const EditToolListStyle = styled.main`
  ${zIndex.hills};
  background-color: ${colors.darkGrayishBlue};
  display: flex;
  flex-wrap: wrap;
  height: ${toolsListVariables.main.height.iphone}px;
  left: 0;
  padding: 16px 20px;
  position: fixed;
  top: ${headerVariables.main.height.iphone}px;
  width: 100%;

  .tools-list-row {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    &.main-tools-row {
      flex-basis: 100%;
      margin-bottom: 16px;

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 70%;
        padding-right: 24px;
      }
    }

    &.scale-navigation-tools-rows {
      flex-basis: 20%;

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: 30%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 30%;
        margin-bottom: 16px;
        padding-right: 0;
      }

      &:not(:last-child) {
        padding-right: 24px;
      }
    }

    &.annotation-tools-rows {
      flex-basis: 55%;

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: 65%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 44%;
      }
    }

    &.segmentation-tools-rows {
      width: 100%;

      .tool-label {
        position: relative;

        &:nth-of-type(1) {
          padding-right: 32px;

          &:after {
            background-color: ${colors.softBlue};
            content: '';
            display: block;
            height: 32px;
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
          }
        }

        &:nth-of-type(2) {
          padding-right: 8px;
        }

        &:nth-of-type(3),
        &:nth-of-type(4) {
          padding-right: 16px;
        }
      }

      .diameter-input-wrapper {
        padding-right: 16px;
      }

      .diameter-range-wrapper,
      .density-limits-wrapper {
        padding-right: 32px;
        position: relative;

        &:after {
          background-color: ${colors.softBlue};
          content: '';
          display: block;
          height: 32px;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
        }
      }

      .density-limits-wrapper {
        display: flex;
        flex-direction: column;

        .density-limits-minimum-wrapper,
        .density-limits-maximum-wrapper {
          align-items: center;
          display: flex;
          flex-wrap: nowrap;
          height: 24px;

          .density-limits-label,
          .density-limits-value {
            ${fontFamily.sourceSansPro.regular};
            color: ${colors.veryPaleBlue};
            font-size: 12px;
            line-height: 20px;
          }

          .density-limits-label {
            padding-right: 12px;
          }

          .density-limits-value {
            padding-left: 12px;
          }
        }
      }

      .select-lung {
        ${fontFamily.sourceSansPro.regular};
        align-items: center;
        background-color: transparent;
        border-radius: 8px;
        color: ${colors.white};
        display: flex;
        flex-wrap: nowrap;
        font-size: 14px;
        height: 48px;
        justify-content: center;
        line-height: 20px;
        padding: 12px;

        &.active {
          background-color: ${colors.mostlyBlack};

          &.left-lung,
          &.right-lung {
            .box {
              border: solid 2px ${colors.softBlue};
            }
          }
        }

        &.left-lung {
          margin-right: 16px;

          .box {
            border: solid 2px ${colors.softOrange};
            background-color: ${colors.softOrange};
          }
        }

        &.right-lung {
          .box {
            border: solid 2px ${colors.softPink};
            background-color: ${colors.softPink};
          }
        }

        .box {
          border-radius: 8px;
          display: block;
          height: 20px;
          margin-right: 8px;
          width: 20px;
        }
      }

      .save-button-wrapper {
        margin-left: 16px;
      }
    }

    .select-exam-container {
      flex-basis: 46%;
      margin-right: 24px;
    }

    .select-tool-container {
      align-items: center;
      display: flex;
      flex-basis: 16%;
      margin-right: 24px;

      .tool-label {
        margin-right: 12px;
      }
    }

    .select-slice-container {
      align-items: center;
      display: flex;
      flex-basis: 38%;
      flex-wrap: nowrap;

      .tool-label {
        margin-right: 12px;
      }

      .navigation-slice-wrapper {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        width: 100%;

        .single-item-navigation-wrapper {
          flex-basis: 61.85%;
          margin-right: 12px;
        }

        .range-navigation-wrapper {
          flex-basis: 38.5%;
          margin-left: 12px;
        }
      }
    }

    .zoom-tool-container {
      align-items: center;
      display: flex;
      margin-right: 24px;
      width: 100%;

      .tool-label {
        margin-right: 12px;
      }
    }

    .navigation-container {
      display: flex;

      .last-navigation-link,
      .next-navigation-link {
        flex-basis: 50%;
      }

      .last-navigation-link {
        margin-right: 8px;
      }

      .next-navigation-link {
        margin-left: 8px;
      }
    }

    .types-select-container {
      align-items: center;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;

      .tool-label {
        ${fontFamily.sourceSansPro.bold}
        margin-right: 8px;
        padding-right: 8px;
        position: relative;

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-right: 16px;
          padding-right: 16px;
          white-space: nowrap;
        }

        &:after {
          background: ${colors.slightlyDesaturatedBlue};
          content: '';
          display: block;
          height: 32px;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
        }
      }

      .select-list-wrapper {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;

        .select-type-wrapper,
        .select-subtype-wrapper {
          flex-basis: 45%;
          padding-right: 4px;

          @media (min-width: ${breakpoints.hd.width}px) {
            padding-right: 8px;
          }
        }

        .select-subtype-wrapper {
          padding-left: 4px;

          @media (min-width: ${breakpoints.hd.width}px) {
            padding-left: 8px;
          }
        }
      }

      .save-button-wrapper {
        flex-basis: 10%;
        padding-left: 4px;

        @media (min-width: ${breakpoints.hd.width}px) {
          padding-left: 8px;
        }
      }
    }
  }

  .tool-label {
    ${fontFamily.sourceSansPro.regular}
    color: ${colors.veryPaleBlue};
    font-size: 14px;
    line-height: 22px;

    &.tool-label-bold {
      ${fontFamily.sourceSansPro.bold}
    }
  }
`;
